// frameworks
import React, { useState, useCallback } from "react";

// constants
import { IMAGES } from "constants/constants";

// styles
import styles from "./ClientMenuIcon.module.scss";

// components
import Hints from "components/Shared/Hints/Hints";
import OptionsMenu from "components/Shared/OptionsMenu/OptionsMenu";

export default function ClientMenuIcon({ room, mutedMusic, mutedSfx, gameState, isPrimaryPlayer }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [openHints, setOpenHints] = useState(false);

    const toggleMenu = useCallback(() => {
        setOpenMenu(prev => { const next = !prev; console.log("toggle menu: ", next); return next; });
        setOpenHints(false);
    }, []);

    const toggleHelp = useCallback(() => {
        setOpenHints(prev => { const next = !prev; console.log("toggle cards: ", next); return next; });
        setOpenMenu(false);
    }, []);

    return (
        <div className={styles.clientMenuContainer}>
            <OptionsMenu room={room} toggleMenu={toggleMenu} menuOpen={openMenu} mutedMusic={mutedMusic} mutedSfx={mutedSfx} gameState={gameState} isPrimaryPlayer={isPrimaryPlayer} />
            <Hints show={openHints} removeBreaks={false} onClose={() => setOpenHints(false)} />
            <img src={IMAGES.SHARED.menuIcon} alt="Menu" className={styles.clientMenuIcon} onClick={toggleMenu} />
            <img src={IMAGES.SHARED.helpIcon} alt="Help" className={styles.clientCardsIcon} onClick={toggleHelp} />
        </div>
    );
}
